export function blurActiveElement(document: Document): void {
	(document.activeElement as HTMLElement)?.blur?.();
}
